import React, {Component} from "react";
import {connect} from "react-redux";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

class ThemeWrapperComponent extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <MuiThemeProvider theme={createMuiTheme({

                overrides: {

                    MuiListSubheader: {
                        root: {
                            lineHeight: '24px',
                        }
                    },

                },

                palette: {
                    primary: {
                        main: this.props.companies.currentCompany.companyColor? this.props.companies.currentCompany.companyColor: '#66BB6A',
                        // main: '#8F100F'
                    },
                    secondary: {
                        main: '#FFFFFF',
                    },
                    action: {
                        main: '#4C4C4C',
                        // hover: '#2E2E2E',
                    },
                    error: {
                        main: '#EF5350',
                    },
                    disabled: {
                        main: '#E6E6E6',
                    },
                    drawerHeader: '#4C4C4C',
                    drawerBackground: '#424242',
                    pageHeader: '#3D4251',
            
                },

            })}>
                <div>
                    { this.props.children }
                </div>
            </MuiThemeProvider>
        )
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        companies: state.companies
    }
  };
  

export default connect(mapStateToProps)(ThemeWrapperComponent);


// WEBPACK FOOTER //
// ./src/ThemeWrapper.js